import React, { useState, useEffect } from 'react';
import ScreenHeading from '../../utilities/ScreenHeading/ScreenHeading';
import ScrollService from '../../utilities/ScrollService';
import Animations from '../../utilities/Animations';
import "./Resume.css";

const Resume = (props) => {
    /* STATES */
    const [selectedBulletIndex, setSelectedBulletIndex] = useState(0);
    const [carousalOffsetStyle, setCarousalOffsetStyle] = useState({});
  
    let fadeInScreenHandler = (screen) => {
      if (screen.fadeInScreen !== props.id) return;
  
      Animations.animations.fadeInScreen(props.id);
    };
    const fadeInSubscription =
      ScrollService.currentScreenFadeIn.subscribe(fadeInScreenHandler);
  
    /* REUSABLE MINOR COMPONENTS */
    const ResumeHeading = (props) => {
      return (
        <div className="resume-heading">
          <div className="resume-main-heading">
            <div className="heading-bullet"></div>
            <span>{props.heading ? props.heading : ""}</span>
            {props.fromDate && props.toDate ? (
              <div className="heading-date">
                {props.fromDate + "-" + props.toDate}
              </div>
            ) : (
              <div></div>
            )}
          </div>
          <div className="resume-sub-heading">
            <span>{props.subHeading ? props.subHeading : ""}</span>
          </div>
          <div className="resume-heading-description">
            <span>{props.description ? props.description : ""}</span>
          </div>
        </div>
      );
    };
  
    /* STATIC RESUME DATA FOR THE LABELS*/
    const resumeBullets = [
      { label: "Education", logoSrc: "education.svg" },
      { label: "Work History", logoSrc: "work-history.svg" },
      { label: "Programming Skills", logoSrc: "programming-skills.svg" },
      { label: "Projects", logoSrc: "projects.svg" },
      { label: "Interests", logoSrc: "interests.svg" },
    ];
  
    //here we have
    const programmingSkillsDetails = [
        {skill: "JavaScript", ratingPercentage: 50},
        {skill: "HTML", ratingPercentage: 85},
        {skill: "CSS", ratingPercentage: 85},
        {skill: "React Js", ratingPercentage: 30},
        {skill: "Python", ratingPercentage: 50},
        {skill: "Bootstrap", ratingPercentage: 75}
    ];
  
    const projectsDetails = [
        {
            title: "Personal Portfolio Website",
            duration: {fromDate: "2021", toDate: "2022"},
            description: "A personal portfolio website to showcase all my details and projects at one place.",
            subHeading: "Technologies Used: ReactJs, Bootstrap, RxJs",
        },
          {
              title: "E-Learning Website",
              duration: {fromDate: "2020", toDate: "2021"},
              description: "This website provides career development courses like udemy, Coursera, etc",
              subHeading: "Technologies Used: HTML, CSS, JavaScript, Bootstrap",
          },
          {
            title: "Weather Application",
            duration: {fromDate: "2021", toDate: "2022"},
            description: "Built a basic React JS weather app using the OpenWeatherMap API. I have used Axios to connect with the API.",
            subHeading: "Technologies Used: HTML, CSS, JavaScript, Bootstrap",
        },
      ];
  
      const resumeDetails = [
        <div className='resume-screen-container' key='education'>
            <ResumeHeading 
            heading={"Amity University, Noida"}
            subHeading={"B.TECH Computer Science"}
            fromDate={"2019"} toDate={"2023"}
            />
            <ResumeHeading 
            heading={"Vrindavan Public School"}
            subHeading={"HSC (12th)"}
            fromDate={"2017"} toDate={"2019"}
            />
            <ResumeHeading 
            heading={"St. Anselm's Sr. Sec. School"}
            subHeading={"SSC (10th)"}
            fromDate={"2005"} toDate={"2017"}
            />
        </div>,
  
      /* WORK EXPERIENCE */
      <div className="resume-screen-container" key="work-experience">
        <div className="experience-container">
          <ResumeHeading
            heading={"Scaler Academy"}
            subHeading={"Technical Content Writer"}
            fromDate={"Jan 2022"} toDate={"Present"}
          />
          <div className="experience-description">
            
          </div>
          <ResumeHeading
            heading={"Cannibals Media"}
            subHeading={"Content Writer"}
            fromDate={"Jan 2022"} toDate={"Mar 2022"}
          />
          <div className="experience-description">
            
          </div>
          <ResumeHeading
            heading={"InternMind"}
            subHeading={"Campus Ambassador"}
            fromDate={"Sep 2020"} toDate={"Oct 2020"}
          />
          <div className="experience-description">
          
          </div>
        </div>
      </div>,
  
      /* PROGRAMMING SKILLS */
      <div
      className="resume-screen-container programming-skills-container"
      key="programming-skills"
    >
      {programmingSkillsDetails.map((skill, index) => (
        <div className="skill-parent" key={index}>
          <div className="heading-bullet"></div>
          <span>{skill.skill}</span>
          <div className="skill-percentage">
            <div
              style={{ width: skill.ratingPercentage + "%" }}
              className="active-percentage-bar"
            ></div>
          </div>
        </div>
      ))}
    </div>,

  
      /* PROJECTS */
      <div className="resume-screen-container" key="projects">
      {projectsDetails.map((projectsDetails, index) => (
        <ResumeHeading
          key={index}
          heading={projectsDetails.title}
          subHeading={projectsDetails.subHeading}
          description={projectsDetails.description}
          fromDate={projectsDetails.duration.fromDate}
          toDate={projectsDetails.duration.toDate}
        />
      ))}
    </div>,
  
      /* Interests */
      <div className="resume-screen-container" key="interests">
        <ResumeHeading
          heading="Workout"
          description="Apart from being a tech enthusiast, i also love to do workout alot as it motivates me in achieving health goals."
        />
        <ResumeHeading
          heading="Music"
          description="Listening to soothing music is something i can never compromise with, skimming through Spotify's pop songs charts is at times the best stress reliever that i can get my hands on."
        />
        <ResumeHeading
          heading="Competitive Gaming"
          description="I like to challenge my reflexes a lot while competing in football games, pushing the rank and having interactive gaming sessions excites me the most."
        />
      </div>,
    ];
  
    const handleCarousal = (index) => {
      let offsetHeight = 360;
  
      let newCarousalOffset = {
        style: { transform: "translateY(" + index * offsetHeight * -1 + "px)" },
      };
  
      setCarousalOffsetStyle(newCarousalOffset);
      setSelectedBulletIndex(index);
    };
  
    const getBullets = () => {
      return resumeBullets.map((bullet, index) => (
        <div
          onClick={() => handleCarousal(index)}
          className={
            index === selectedBulletIndex ? "bullet selected-bullet" : "bullet"
          }
          key={index}
        >
          <img
            className="bullet-logo"
            src={require(`../../assets/Resume/${bullet.logoSrc}`)}
            alt="B"
          />
          <span className="bullet-label">{bullet.label}</span>
        </div>
      ));
    };
  
    const getResumeScreens = () => {
      return (
        <div
          style={carousalOffsetStyle.style}
          className="resume-details-carousal"
        >
          {resumeDetails.map((ResumeDetail) => ResumeDetail)}
        </div>
      );
    };
  
    useEffect(() => {
      return () => {
        /* UNSUBSCRIBE THE SUBSCRIPTIONS */
        fadeInSubscription.unsubscribe();
      };
    }, [fadeInSubscription]);
  
    return (
      <div
        className="resume-container screen-container fade-in"
        id={props.id || ""}
      >
        <div className="resume-content">
          <ScreenHeading title={"Resume"} subHeading={"My formal Bio Details"} />
          <div className="resume-card">
            <div className="resume-bullets">
              <div className="bullet-container">
                <div className="bullet-icons"></div>
                <div className="bullets">{getBullets()}</div>
              </div>
            </div>
  
            <div className="resume-bullet-details">{getResumeScreens()}</div>
          </div>
        </div>
      </div>
    );
  };
  
  export default Resume;